"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPLOAD_VIRTUAL_BACKGROUND_FAILURE_MSG = exports.UPLOAD_INFO = exports.RESET_USER_VIRTUAL_BACKGROUND = exports.ERROR_TITLE = exports.ERROR_DESCRIPTION = exports.DEVICE_NOT_SUPPORTED_MESSAGE = exports.DELETE_VIRTUAL_BACKGROUND_FAILURE_MSG = exports.BACKGROUND_OPTIONS = void 0;
var BACKGROUND_OPTIONS = exports.BACKGROUND_OPTIONS = {
  NONE: 'None',
  BLUR: 'Blur',
  CUSTOM: 'Custom'
};
var ERROR_TITLE = exports.ERROR_TITLE = 'Virtual Background Upload Failed';
var ERROR_DESCRIPTION = exports.ERROR_DESCRIPTION = 'You can only upload one file at a time.';
var UPLOAD_INFO = exports.UPLOAD_INFO = {
  SUPPORTED_FILE_TYPES: 'Supported file types: JPG, JPEG, PNG',
  RECOMMENDED_SIZE: 'Recommended Size: 1920 x 1080 pixels'
};
var RESET_USER_VIRTUAL_BACKGROUND = exports.RESET_USER_VIRTUAL_BACKGROUND = 'RESET_USER_VIRTUAL_BACKGROUND';
var DELETE_VIRTUAL_BACKGROUND_FAILURE_MSG = exports.DELETE_VIRTUAL_BACKGROUND_FAILURE_MSG = 'Something went wrong while deleting your file. Please try again.';
var UPLOAD_VIRTUAL_BACKGROUND_FAILURE_MSG = exports.UPLOAD_VIRTUAL_BACKGROUND_FAILURE_MSG = 'Something went wrong while uploading your file. Please try again.';
var DEVICE_NOT_SUPPORTED_MESSAGE = exports.DEVICE_NOT_SUPPORTED_MESSAGE = '*Your device isn’t currently supporting this feature.';